/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class CliService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Cli Install Sh
     * @returns any Successful Response
     * @throws ApiError
     */
    public cliInstallSh(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/cli/install.sh',
        });
    }

    /**
     * Cli Install Ps1
     * @returns any Successful Response
     * @throws ApiError
     */
    public cliInstallPs1(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/cli/install.ps1',
        });
    }

    /**
     * Cli Download
     * @returns void
     * @throws ApiError
     */
    public cliDownload({
        os,
        arch,
    }: {
        /**
         * Target operating system
         */
        os: string,
        /**
         * Target architecture
         */
        arch: string,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/cli/download',
            query: {
                'os': os,
                'arch': arch,
            },
            errors: {
                307: `Successful Response`,
                422: `Validation Error`,
            },
        });
    }

}
